import { render, staticRenderFns } from "./preview-basic.vue?vue&type=template&id=a163e77a&scoped=true"
import script from "./preview-basic.vue?vue&type=script&lang=js"
export * from "./preview-basic.vue?vue&type=script&lang=js"
import style0 from "./preview-basic.vue?vue&type=style&index=0&id=a163e77a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a163e77a",
  null
  
)

export default component.exports